import React from 'react';
import { styled } from '@linaria/react';

const PreBoop = ({ children }: { children: React.ReactNode }) => {
  const [isDepressed, setIsDepressed] = React.useState(false);

  const tap = (ev: any) => {
    if (typeof ev.key === 'string' && ev.key !== 'Enter') {
      return;
    }
    setIsDepressed((d) => !d);
  };

  return (
    <Wrapper
      onClick={tap}
      style={{ transform: isDepressed ? 'rotate(20deg)' : '' }}
    >
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.span`
  display: inline-block;
  transition: transform 200ms;

  &:hover {
    transform: rotate(20deg);
  }
`;

export default PreBoop;
